module.exports = __webpack_public_path__ + "static/media/Toyota-Bold.755ac808.ttf";